import Vue from "vue";
import Router from "vue-router";
import axios from "axios";

// 主体框架
const DefaultContainer = () => import("@/containers/DefaultContainer");
// 路由页面
const Index = () => import("@/views/Index");
const Vulnerability = () => import("@/views/Vulnerability");
const Rank = () => import("@/views/Rank");
const Notices = () => import("@/views/Notices");
const NoticeDetail = () => import("@/views/NoticeDetail");
const About = () => import("@/views/About");
const UserContainer = () => import("@/containers/UserContainer.vue");
const UserInfo = () => import("@/views/User/Info.vue");
const UserVulnerabilities = () => import("@/views/User/Vulnerabilities.vue");
const UserExchange = () => import("@/views/User/Exchange.vue");
const UserPayment = () => import("@/views/User/Payment.vue");
const UserMessage = () => import("@/views/User/Message.vue");
// 错误页
const Error = () => import("@/views/Error");

Vue.use(Router);

let vue = new Vue();

/* 路由列表 */
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "主页",
      component: DefaultContainer,
      redirect: "/",
      children: [
        {
          path: "",
          name: "首页",
          component: Index,
          meta: { auth: false },
        },
        {
          path: "vulnerability",
          name: "提交漏洞",
          component: Vulnerability,
          meta: { auth: true },
        },
        {
          path: "rank",
          name: "荣誉榜",
          component: Rank,
          meta: { auth: false },
        },
        {
          path: "notices",
          name: "公告",
          component: Notices,
          meta: { auth: false },
        },
        {
          path: "notices/:id",
          name: "公告详情",
          component: NoticeDetail,
          meta: { auth: false },
        },
        {
          path: "about",
          name: "关于我们",
          component: About,
          meta: { auth: false },
        },
        {
          path: "user",
          name: "用户中心",
          component: UserContainer,
          redirect: "/user/info",
          meta: { title: "用户中心", auth: true },
          children: [
            {
              path: "info",
              name: "个人中心",
              component: UserInfo,
            },
            {
              path: "vulnerabilities",
              name: "漏洞列表",
              component: UserVulnerabilities,
            },
            {
              path: "payment",
              name: "安全币兑换",
              component: UserPayment,
            },
            {
              path: "exchange",
              name: "礼品兑换",
              component: UserExchange,
            },
            {
              path: "message",
              name: "消息中心",
              component: UserMessage,
            },
          ],
        },
      ],
    },
    // Error Page
    {
      path: "/404",
      name: "404",
      component: Error,
      meta: { auth: false, title: "404 Page Not Found" },
    },
    {
      path: "/503",
      name: "503",
      component: Error,
      meta: { auth: false, title: "503 Service Unavailable" },
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});

/* 登录拦截 */
router.beforeEach(async (to, from, next) => {
  // 拉取数据
  const requestUser = axios.post(
    "/p/auth/check",
    { cached: true },
    { baseURL: "https://account.wps.cn" }
  );
  const requestAsset = axios.get("/api/src/user/asset");
  // 获取数据
  await axios
    .all([requestUser, requestAsset])
    .then(
      axios.spread((...responses) => {
        let data = [];
        if (
          responses[0] &&
          responses[0].status === 200 &&
          responses[0].data.hasOwnProperty("result") &&
          responses[0].data.result === "ok"
        ) {
          data = responses[0].data;
        }
        if (
          responses[1] &&
          responses[1].status === 200 &&
          responses[1].data.hasOwnProperty("result") &&
          responses[1].data.result === "ok"
        ) {
          data.messageNumber = responses[1].data["unread_count"];
          data.coin = responses[1].data["coin"];
          data.score = responses[1].data["score"];
          data.lastAgreementId = responses[1].data["last_agreement_id"];
        }
        window.USER = data;
        next();
      })
    )
    .catch((errors) => {
      // react on errors.
      next();
    });
  // 判断是否需要拦截
  if (!window.hasOwnProperty("USER") && to.matched.some((r) => r.meta.auth)) {
    next(false); // 禁止跳转
    vue
      .$confirm("您未登录，是否前往登录？", "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
      .then(() => {
        window.location = `https://account.wps.cn/login?cb=${encodeURIComponent(
          location.href
        )}`;
      })
      .catch(() => {
        window.location = "/";
      });
  }
});

export default router;
